import { ModalWindow } from '@cian/ui-kit';
import * as React from 'react';

import { Footer } from '../inner/Footer';

interface IPromoDescriptionModalProps {
  open: boolean;
  onClose(): void;
  builderName?: string | null;
  logoUrl?: string | null;
  phoneNumber?: string;
}

export const PromoContactModal = (props: IPromoDescriptionModalProps) => {
  return (
    <ModalWindow
      open={props.open}
      content={props.phoneNumber && <h1>{props.phoneNumber}</h1>}
      escape
      fixed={false}
      footer={
        <Footer
          authorLabel="Акция от застройщика"
          authorName={props.builderName}
          authorLogoUrl={props.logoUrl}
          isDescriptionModal={false}
        />
      }
      maxWidth={486}
      onClose={props.onClose}
      outside
      size="M"
      title="Контакты"
    />
  );
};

PromoContactModal.displayName = 'PromoContactModal';
